import Result from 'folktale/result'
import formatApiError from '@v/util/formatApiError.js'

export function upsertBooking(apiClient) {
  return async upsertModel => {
    const bookingKey = upsertModel.booking?.Key
    const updateCall = () => apiClient.put(`bookings/${bookingKey}/update`, upsertModel)
    const createCall = () => apiClient.post('bookings/create', upsertModel)
    const callParam = bookingKey
      ? { call: updateCall, successMessage: 'Booking saved' }
      : { call: createCall, successMessage: 'Booking created' }
    return await save(callParam)
  }
}

async function save({ call, successMessage }) {
  try {
    const response = await call()
    return Result.Ok({ response, successMessage })
  } catch (e) {
    const messages = handleSaveError(e)
    return Result.Error(messages)
  }
}

function handleSaveError(e) {
  if (e.response?.status === 400 && e.response?.data?.message === '"EmailAddressInUse"') {
    return {
      errorMessage: null,
      userMessage: 'Customer email is in use',
    }
  }
  return formatApiError(e, 'Could not save booking')
}
